const facilityAssignmentPlanRoute = createApiRoute(ApiModule.DEMAND_PLANNING, ApiDataModel.FACILITY_ASSIGNMENT_PLAN)

export const apiFacilityAssignmentPlan = {
	fetchFacilityAssignmentPlan: async (): Promise<IFacilityAssignmentPlanPayloadModel> => {
		const { data } = await apiCommon<IFacilityAssignmentPlanPayload>(facilityAssignmentPlanRoute, {
			method: 'GET',
		})

		return FacilityAssignmentPlan(data ?? { rules: [] })
	},

	updateFacilityAssignmentPlan: async (plan: IFacilityAssignmentPlanPayloadModel): Promise<void> => {
		await apiCommon(facilityAssignmentPlanRoute, {
			method: 'PUT',
			body: facilityAssignmentPlanToJSON(plan),
		})
	},
}
